module.exports = __webpack_public_path__ + "assets/img/video.9a1da2d5.webp";